// extracted by css-extract-rspack-plugin
export default {"contents":"NotFound__contents--ELsIS","title":"NotFound__title--CECCA","cardWrap":"NotFound__cardWrap--hv7tC"};